const executeTableNames = [
    'PMT_QUERY',
    'PMT_DIREC',
    'DATA_W263_CHAIKA',
    'DATA_HL7',
    'DATA_X_RAY_RADIOGRAPH',
    'DATA_AMBULAT_PATIENT_COUPON',
    'DATA_W263_LIFE_ANAMNESIS_2',
    'DATA_F039_DENTIST',
    'DATA_LIFE_ANAMNESIS',
    'DATA_F039_ORTHOPEDIST',
];

export function isTableExecute(tableName: string): boolean {
    return executeTableNames.some(executeName => tableName.includes(executeName));
}

const executeFieldNames = [
    'DIAG_STATUS',
    'N_LINE',
    'DIAGNOZ_ISKLUCHEN',
    '__TIP_DOPUSKA_NEDOPUSKA',
    'NAZVANIE',
    '__TIP',
    'OSOBENNOSTI',
    'SOGLASIE',
    'SANACIQ',
    'EPIDANAMNEZ',
    '__LPU',
    'DATA',
    'EKSPERTNYY_ANAMNEZ_O_TRUD',
    'FORMA_086_U',
    'POLYA_DLYA_SKRIPTA',
    '__VRT_EMBRIOLOG',
    'COMPLETED_DATE',
    'CONS_DURATION',
    'PARTNERSKOE_LPU',
    'ZABRANO',
    'ZABRAL',
    'NOMER_ZUBA',
    '__SEX',
    'AGE_FROM',
    'AGE_TO',
    '__STATUS',
    'V_LIST_UTOCHNENNYH_DIAGNO',
    'diag_ext_count',
    'CODE_1',
    'DATE_CONS',
    'ERR',
    'CODE',
    'MEDOTVOD_PRIZNAK',
    'KOMMENTARII_I_ZHALOBY',
    'NORM_VIEW',
    'IS_TASK',
    'LAB_NAME',
    'dyn_0',
];

export const executeFieldNamesSet = new Set(executeFieldNames);

export const LEGACY_FIELD_LABLE = {
    BEZ_C_SPH_OD: 'sph OD',
    BEZ_C_CYL_OD: 'cyl OD',
    BEZ_C_AX_OD: 'ax OD',
    BEZ_C_SPH_OS: 'sph OS',
    BEZ_C_CYL_OS: 'cyl OS',
    BEZ_C_AX_OS: 'ax OS',
    S_C_SPH_OD: 'sph OD',
    S_C_CYL_OD: 'cyl OD',
    S_C_AX_OD: 'ax OD',
    S_C_SPH_OS: 'sph OS',
    S_C_CYL_OS: 'cyl OS',
    S_C_AX_OS: 'ax OS',
    B_K_OD1: 'б/к OD',
    SPH_OD1: 'sph OD',
    CYL_OD1: 'cyl OD',
    AX_OD1: 'ax OD',
    RAVNO: 'С/К',
    B_K_OS1: 'б/к OS',
    SPH_OS1: 'sph OS',
    CYL_OS1: 'cyl OS',
    AX_OS1: 'ax OS',
    RAVNO1: 'С/К',
    PODVIZHNOST_GLAZNYH_YABLO: 'Подвижность глазных яблок',
    VEKI_OD: 'Веки',
    SLEZN_E_ORGAN_OD: 'Слезные органы',
    BOLEZNEN_PRI_PAL_P_OD: 'Болезнен при пальп',
    F_RUSTALIK_OD: 'Хрусталик',
    KON_YNKTIVA_OD: 'Конъюнктива',
    PEREDNQQ_KAMERA_OD: 'Передняя камера',
    PERIKORNEAL_NAQ_IN_OD: 'Перикорнеальная ин',
    RADUGKA_OD: 'Радужка',
    ROGOVICA_OD: 'Роговица ',
    ZRAHKOK_OD: 'Зрачкок',
    REFLEKS_OD: 'Рефлекс',
    STEKLOVIDNOE_TELO_OD: 'Стекловидное тело',
    GLAZNOE_DNO_MAK_OD: 'Глазное дно-мак',
    GLAZNOE_DNO_PARAMAK_OD: 'Глазное дно-парамак',
    GLAZNOE_DNO_SOSUD_OD: 'Глазное дно-сосуды',
    GLAZNOE_DNO_PERIF_OD: 'Глазное дно-периф',
    DZI_OD: 'ДЗН',
    GLAZNOE_DNO_OD: 'Глазное дно',
    PODVIZHNOST_GLAZNYH_YABL1: 'Подвижность глазных яблок',
    VEKI_OS: 'Веки',
    SLEZN_E_ORGAN_OS: 'Слезные органы',
    BOLEZNEN_PRI_PAL_P_OS: 'Болезнен при пальп',
    F_RUSTALIK_OS: 'Хрусталик',
    KON_YNKTIVA_OS: 'Конъюнктива',
    PEREDNQQ_KAMERA_OS: 'Передняя камера',
    PERIKORNEAL_NAQ_IN_OS: 'Перикорнеальная ин',
    RADUGKA_OS: 'Радужка',
    ROGOVICA_OS: 'Роговица ',
    ZRAHKOK_OS: 'Зрачкок',
    REFLEKS_OS: 'Рефлекс',
    STEKLOVIDNOE_TELO_OS: 'Стекловидное тело',
    GLAZNOE_DNO_MAK_OS: 'Глазное дно-мак',
    GLAZNOE_DNO_PARAMAK_OS: 'Глазное дно-парамак',
    GLAZNOE_DNO_SOSUD_OS: 'Глазное дно-сосуды',
    GLAZNOE_DNO_PERIF_OS: 'Глазное дно-периф',
    DZI_OS: 'ДЗН',
    GLAZNOE_DNO_OS: 'Глазное дно',
    SKIASKOPIQ_OD_SPH: 'Скиаскопия OD Sph1',
    SKIASKOPIQ_OD_SPH2: 'Скиаскопия OD Sph2',
    SKIASKOPIQ_OS_SPH1: 'Скиаскопия OS Sph1',
    SKIASKOPIQ_OS_SPH2: 'Скиаскопия OS Sph2',

    BIFOK_OD: 'OD',
    BIFOK_OS: 'OS',
    BIFOKDPP: 'Dpp (мм)',

    BLIZ_OD: 'OD',
    BLIZ_OS: 'OS',
    BLIZDPP: 'Dpp (мм)',

    DAL_OD: 'OD',
    DAL_OS: 'OS',
    DAL_DPP: 'Dpp (мм)',
    DOPOLNITEL_NO: 'Дополнительно',
};
